export enum ActionCode {
  SUCCESS = "SUCCESS",
  NOACTION = "NOACTION",
  FAILURE = "FAILURE",
  CANCELLED = "CANCEL",
  ERROR = "ERROR",
}
